import styled from 'styled-components';

export const StyledPressLogos = styled.section`
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding: ${props => props.theme.spacing(5, 0)};
  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(11, 5)};
  }
`;

export const MobilePressLogoContainer = styled.div`
  @media ${props => props.theme.tablet} {
    display: none;
  }
`;

export const PressLogoContainer = styled.div`
  display: none;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: flex-start;
  @media ${props => props.theme.tablet} {
    display: flex;
  }
  @media ${props => props.theme.laptop} {
    flex-flow: row nowrap;
    align-items: unset;
    max-width: 1260px;
    margin: 0 auto;
  }
`;

export const LogoWrapper = styled.div`
  flex: 0 0 auto;
  margin: ${props => props.theme.spacing(9, 0, 6)};
  padding: 0 20px;
  @media ${props => props.theme.tablet} {
    padding: 0 16px;
    width: ${props => `${100 / props.count}%`};
  }
`;

export const StyledPressLogo = styled.div`
  max-width: 100%;
  text-align: center;
  width: 350px;
  ${props => !props.quote && 'align-self: center;'}
`;

export const LogoContainer = styled.div`
  max-width: 100%;
  width: 170px;
  height: 60px;
  display: flex;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
`;

export const Quote = styled.p`
  ${props => props.theme.typography.heading4}
  color: ${props => props.theme.colors.text.lighter};
  margin-top: ${props => props.theme.spacing(10)};
`;
